import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Badge} from 'react-ui';
import {FilterLabel} from '../types/FilterLabel';
import {
    Language,
    MultiLanguageTextModel,
    QueryModel,
} from 'ts-core';
import {useBalloonEventsData} from '../contexts/EventData';

interface FilterLabelBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    language?: Language;
    filterLabel: FilterLabel;
    inverted?: boolean;
}

export function FilterLabelBadge(props: FilterLabelBadgeProps) {
    const queryModelRef = useRef<QueryModel>(new QueryModel(false));

    const {events} = useBalloonEventsData();
    const {inverted, filterLabel, language, ...rest} = props;

    const [label, setLabel] = useState<string>('');

    useEffect(() => {
        if (!language) return;
        const text = new MultiLanguageTextModel(filterLabel.label);
        const translatedText = text.get(language);
        if (translatedText) {
            setLabel(translatedText.text);
        }
    }, [filterLabel.label, language]);

    return (
        <div className={`filter-label-badge rounded-full p-1 border-2`} style={{border: `2px solid ${inverted ? 'transparent' : filterLabel.color}`}}>
            <Badge color={filterLabel.color} {...rest}>
                <span
                  style={{
                      color: 'white',
                      fontSize: '13px',
                  }}
                  className="whitespace-nowrap drop-shadow-lg font-bold"
                >
                    {label}
                    <div
                      dangerouslySetInnerHTML={{__html: filterLabel.icon}}
                      style={{
                          fontFamily: 'fontAwesome',
                          marginLeft: 5,
                          display: 'inline-block',
                          color: 'white',
                      }}
                    />
                </span>
            </Badge>
        </div>
    );
}
